@import '../../../theme.scss';

verdocs-field-attachment {
  font-family: $verdocs-primary-font;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: block;
  font-size: 11px;
  position: relative;
  scroll-margin: 20px 0;
  background-color: transparent;
  transform-origin: bottom left;

  label {
    top: -14px;
    left: -1px;
    height: 14px;
    color: white;
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #4a4a99;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  &.disabled svg {
    opacity: 0.5;

    span {
      cursor: inherit;
    }
  }

  .attach {
    // This is needed to bring down the cursor from the parent element, which is where interactjs applies it
    cursor: inherit;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--verdocs-field-radius);
  }

  &.required {
    .attach {
      border: 1px solid var(--verdocs-required-field-border);
    }
  }

  verdocs-button-panel {
    top: 1px;
    left: -19px;
    opacity: 0.5;
    z-index: 1000;
    cursor: pointer;
    position: absolute;
    transform: scale(0.6);

    &[data-active],
    &:hover {
      opacity: 1;
    }

    .icon {
      svg {
        fill: #333333;
      }

      &:hover {
        svg {
          fill: #000000;
        }
      }
    }
  }

  .settings-icon {
    position: absolute;
    top: -3px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}
